module.exports = require("filepond-plugin-file-validate-type");